import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { useSaveFileLocally } from '@/hooks/useSaveFileLocally.hook';
import { upliftHttpClient } from '@/services/http/clients/upliftHttpClient';
import { notificationService } from '@/services/notification/notification.client';

export default function useDownloadUpliftFile() {
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const { saveFileLocally } = useSaveFileLocally();

  const downloadFile = async (id: UUID, fileName: string) => {
    toggleLoadingAnimation(true);

    try {
      if (!id) {
        throw new Error('Invalid file id');
      }

      const requestUrl = `/Documents/download/${id}`;
      const response = await upliftHttpClient.get(requestUrl, {
        responseType: 'arraybuffer',
      });

      const blob = new Blob([response.data]);
      saveFileLocally(blob, fileName);
    }
    catch (err: any) {
      notificationService.open({
        title: 'Error',
        text: err?.message ?? DEFAULT_ERROR_MESSAGE,
        type: 'danger'
      });
    }
    finally {
      toggleLoadingAnimation(false);
    }
  };

  return {
    downloadFile
  } as const;
}

